import { graphql, useStaticQuery } from 'gatsby';

// Types
import type { ContentfulTemplateCaseStudyConnection } from 'graphqlTypes';

interface CaseStudyArticlesData {
  cases: ContentfulTemplateCaseStudyConnection;
}

const AllCaseStudyItems = () => {
  const { cases } = useStaticQuery<CaseStudyArticlesData>(graphql`
    query getAllCaseStudyQuery {
      cases: allContentfulTemplateCaseStudy(sort: { fields: publishDate, order: DESC }) {
        nodes {
          ...contentfulTemplateCaseStudy
        }
      }
    }
  `);

  const allItems = cases?.nodes;

  return allItems;
};

export default AllCaseStudyItems;
